import { take } from 'rxjs/operators';
import { SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';

import { InstDynListItemModalComponent } from '../shared/component/institute-dyn-list-item-modal/institute-dyn-list-item-modal.component';
import { DepartamentsModalComponent } from '../shared/component/departaments-modal/departaments-modal.component';
import { NotificationModalComponent } from '../shared/component/notification-modal/notification-modal.component';
import { InstituteDepartamentService } from '../shared/service/institute-departament.service';
import { MessageComponent } from '../shared/component/message/message.component';
import { InstituteTypeService } from '../shared/service/institute-type.service';
import { DepartamentService } from '../shared/service/departament.service';
import { InstituteTypeModel } from "../shared/model/institute-type.model";
import { ReturnMessageModel } from '../shared/model/return-message.model';
import { InstituteService } from '../shared/service/institute.service';
import { DepartamentModel } from '../shared/model/departament.model';
import { InstituteModel } from '../shared/model/institute.model';

@Component({
  styles: [''],
  selector: 'app-institute',
  templateUrl: './institute.component.html',
})
export class InstituteComponent implements OnInit {

  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(DepartamentsModalComponent) modal: DepartamentsModalComponent;
	@ViewChild(NotificationModalComponent) notificationModal: NotificationModalComponent;
	@ViewChild(InstDynListItemModalComponent) dynamicListItemModal: InstDynListItemModalComponent;

  lastEvent: any;
  totalRecords: number;
  loadedEmailList: boolean = false;

  institutes: InstituteModel[] = [];
  institute: InstituteModel = new InstituteModel();

  dropdownInstituteType: SelectItem[] = [];

  constructor(
    private instituteService: InstituteService, 
		private translateService: TranslateService,
    private departamentService: DepartamentService,
    private instituteTypeService: InstituteTypeService,
    private instituteDepartamentService: InstituteDepartamentService
  ) {

    this.departamentService.getPaginated(0, 1000).subscribe(result => {
      result.rows.forEach((item: DepartamentModel) => {
        let departament = { 
          label: item.name,
          data: item.id,
        };

        this.modal.departaments.push(departament);
      });
    });

  }

  ngOnInit() {
    this.instituteTypeService.getPaginated(0, 1000).subscribe(types => {
      types['rows'].forEach(type => {
          this.dropdownInstituteType.push({label: type.name, value: type});
      });
    });
  }

  lazy(e) {
    this.lastEvent = e;

    const { first: init, rows: end, filters } = e;

    const city = filters['city'] ? filters['city'].value : null;
    const name = filters['name'] ? filters['name'].value : null;

    this.instituteService.getPaginated({ init, end, city, name })
    .subscribe((institutes) => {
      this.institutes = institutes['rows'] as InstituteModel[];
      this.totalRecords = institutes['count'];
    });
  }

  onSelect({ data }) {
    this.loadedEmailList = false;

    if (data && data.id) {
      this.instituteService.getById(data.id).pipe(take(1))
      .subscribe((institute: InstituteModel) => {
        this.institute = institute;
        this.loadedEmailList = true;
      });
    } else console.error('ID not exists on this selection', data);
  }

  onSave() {
    this.instituteService.save(this.institute).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message);
      else this.message.success(r.message);

      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

  saveEmails({ emails }) {
    if (emails && emails.length) {
      this.institute.institute_mails = emails.map(({ id: email_id, ...otherProps }) => {
        return { email_id, institute_id: this.institute.id, ...otherProps };
      });
    }

    this.onSave();
  }

  // Verify this
  saveInstituteDynListItems({ dynamicListItems }) {
    if (dynamicListItems && dynamicListItems.length) {
      this.institute.institute_dyn_list_items = dynamicListItems.map(({ id: dyn_list_item_id, ...otherProps }) => {
        return { dyn_list_item_id, institute_id: this.institute.id, ...otherProps };
      });
    }

    this.onSave();
  }

  onDelete() {
    this.instituteService.delete(this.institute.id).subscribe((r: ReturnMessageModel) => {
      if (r.error) this.message.error(r.message); else this.message.success(r.message);
      this.lazy(this.lastEvent);
      this.onNew();
    });
  }

	openEmailModal(e) {
		this.notificationModal.display = true;
	}

	openDynamicListItemModal(e) {
		this.dynamicListItemModal.display = true;
	}

  onNew() {
    this.institute = new InstituteModel();
  }

  validate(): boolean {
    return InstituteModel.validate(this.institute);
  }

  onInstituteTypeChange(e) {
    if (e.value) {
        const instituteType = e.value as InstituteTypeModel;
        this.institute.institute_type_id = instituteType.id;
    } else {
        this.institute.institute_type_id = null
    }
  }

  showDepartamentModal(id) {
    this.modal.selectedDepartaments = [];

    this.instituteDepartamentService.getDepartamentsByInstituteId(id).subscribe(items => {
      items.forEach(item => {
        this.modal.departaments.forEach(departament => {
          if(item.departament_id == departament.data) {
            this.modal.selectedDepartaments.push(departament);
          }
        })
      });
    });
    this.modal.show();
  }

  onSaveDepartaments() {
    const departaments = [];
    this.modal.selectedDepartaments.forEach(departament => {
      departaments.push(departament.data);
    })    

    this.instituteDepartamentService.save(this.institute.id, departaments)
    .subscribe((r: ReturnMessageModel) => {
      if(r.error) return this.message.error(r.message);

      this.modal.hide();
      this.message.success();
    });
  }

  translate = (key: string) => this.translateService.instant(key || 'invalid_key');
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/institute/institute.component.ts